import React from "react";
import { useCurrentUser, useSubscriptionEligibleTo } from "@hooks/use-current-user";
import DrawerPostReturnedSubscriptionWaiting from "./DrawerPostReturnedSubscriptionWaiting";
import DrawerPostReturned from "./DrawerPostReturned";
import DrawerUnlockEarlyTunnel from "../DrawerUnlockEarlyTunnel";

function DrawerModalClosetPostReturned() {
  const user = useCurrentUser();
  const subscriptionWithSuspensionWaiting = user?.subscription?.suspension_waiting;
  const subscriptionEligibleTo = useSubscriptionEligibleTo();

  if (subscriptionWithSuspensionWaiting) return <DrawerPostReturnedSubscriptionWaiting />;
  if (subscriptionEligibleTo === "unlock_early") return <DrawerUnlockEarlyTunnel />;

  return <DrawerPostReturned />;
}

export default DrawerModalClosetPostReturned;
